<template>
  <section>
    <nav class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <p class="level-item">
          <a class="button is-primary" @click="onAdd">
            <b-icon icon="plus"></b-icon>
            <span>{{ $t('attributes.add') + $t('attributes.option') }}</span>
          </a>
        </p>
      </div>
    </nav>

    <b-table :data="options" narrowed bordered :mobile-cards="false">
      <b-table-column
        field="sequence"
        :label="$t('attributes.sort')"
        :width="80"
        numeric
        v-slot="props"
      >
        {{ props.row.sequence }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        field="quantity"
        :label="$t('attributes.signup_quantity')"
        v-slot="props"
      >
        {{ props.row.sign_up_quantity }}
      </b-table-column>

      <b-table-column
        field="quantity"
        :label="$t('attributes.remainder_quantity')"
        v-slot="props"
      >
        {{ props.row.remainder_quantity }}
      </b-table-column>

      <b-table-column
        field="quantity"
        :label="$t('attributes.quantity')"
        v-slot="props"
      >
        {{ props.row.quantity }}
      </b-table-column>

      <b-table-column
        field="adult_cost"
        :label="$t('attributes.adult_fee')"
        v-slot="props"
      >
        {{ props.row.adult_cost || $t('attributes.free') }}
      </b-table-column>

      <b-table-column
        field="child_cost"
        :label="$t('attributes.child_cost')"
        v-slot="props"
      >
        {{ props.row.child_cost || $t('attributes.free') }}
      </b-table-column>

      <b-table-column
        field="infant"
        :label="$t('attributes.infant')"
        v-slot="props"
      >
        {{ props.row.baby_cost || $t('attributes.free') }}
      </b-table-column>

      <b-table-column :width="200" v-slot="props">
        <div class="buttons">
          <b-button
            type="is-primary"
            outlined
            @click.prevent="onModify(props.row)"
          >
            {{ $t('attributes.modify') }}
          </b-button>
          <b-button
            type="is-danger"
            outlined
            @click.prevent="onDelete(props.row)"
          >
            {{ $t('attributes.delete') }}
          </b-button>
        </div>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isFormModalActive"
      :can-cancel="['escape', 'x']"
      :width="1200"
      has-modal-card
    >
      <spot-form :spot="selectedSpot" :area="area" @send="onSend" />
    </b-modal>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import SpotForm from './SpotForm'

export default {
  name: 'SpotList',
  components: { SpotForm },

  props: {
    question: {
      required: true,
      type: Object
    },
    area: {
      type: String,
      required: true
    }
  },
  data() {
    const options = [...this.question.spot_options].sort(
      (a, b) => a.sequence - b.sequence
    )

    return {
      question_id: this.question.id,
      options: options,

      isFormModalActive: false,
      selectedSpot: null
    }
  },
  methods: {
    onAdd() {
      this.selectedSpot = {}
      this.isFormModalActive = true
    },
    onModify(item) {
      this.selectedSpot = item
      this.isFormModalActive = true
    },
    onSend(item) {
      if (!item.id) {
        this.createOption(item)
      } else {
        this.updateOption(item)
      }
    },
    onDelete(item) {
      this.$buefy.dialog.confirm({
        message: this.$t('attributes.confirm_delete'),
        onConfirm: () => {
          this.deleteOption(item)
        }
      })
    },
    async createOption(item) {
      const api = `${TRAVEL_GROUPS_API}/spot-questions/${this.question_id}/spots`

      this.sending = true
      try {
        const res = await this.axios.post(api, item)
        const _item = res.data.data

        const options = [...this.options, _item]
        this.options = options.sort((a, b) => a.sequence - b.sequence)

        this.isFormModalActive = false

        notifyService.success(this.$t('attributes.add_succeed'))
      } catch (e) {
        notifyService.create_error(e)
      } finally {
        this.sending = false
      }
    },
    async updateOption(item) {
      const api = `${TRAVEL_GROUPS_API}/spots/${item.id}`

      this.sending = true
      try {
        const res = await this.axios.put(api, item)
        const _item = res.data.data

        const idx = this.options.findIndex(s => s.id === _item.id)
        const options = [...this.options]
        options[idx] = _item
        this.options = options.sort((a, b) => a.sequence - b.sequence)

        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    async deleteOption(item) {
      const api = `${TRAVEL_GROUPS_API}/spots/${item.id}`

      this.sending = true
      try {
        await this.axios.delete(api)
        this.options = this.options.filter(i => i.id !== item.id)
        notifyService.success(this.$t('attributes.delete_succeed'))
      } catch (e) {
        notifyService.delete_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
